'use strict';

var angular = require('angular');
var dependencies = [];
module.exports = angular.module('AVRO.SystemConfiguration.ImportCsvErrorLog', dependencies).controller('ImportCsvErrorLogController', require('./controllers/ImportCsvErrorLogController')).directive('rmImportCsvErrorLog', require('./directives/ImportCsvErrorLogDirective'));